import { render, staticRenderFns } from "./accountapps.vue?vue&type=template&id=886cb1d4&"
import script from "./accountapps.vue?vue&type=script&lang=js&"
export * from "./accountapps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports